import { height, width } from "@mui/system";

const styles = (theme) => ({
  buttonRefresh: {
    color: theme.palette.text.textContrast,
    borderColor: theme.palette.text.main,
    lineHeight: 1,
    minWidth: "unset",
    width: "40px",
    height: "40px",
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  containerChipsGrupos: {
    display: "flex",
    width: "100%", // O container preenche o input
    alignItems: "center", // Centraliza verticalmente
    overflow: "hidden", // Garante segurança contra quebras
  },
  autocompleteFilter: {
    width: "100%",
    maxWidth: 500,
  },
  chipHost: {
    fontSize: "0.7rem",
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.black.medium
        : theme.palette.colors.black.light, // Fundo sutil
    color: "inherit",
    opacity: 0.8, // Texto levemente apagado
    padding: "1px 8px",
    borderRadius: "12px", // Bordas arredondadas (estilo "pill")
    marginLeft: "8px",
    whiteSpace: "nowrap",
    fontWeight: "bold",
  },
  boxLine: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    background:
      theme.palette.mode === "dark"
        ? theme.palette.background.modalContrast
        : theme.palette.colors.white.light,
    borderRadius: "6px",
    p: 1,
  },

  chipOption: {
    flex: 1,
    minWidth: 0,
    fontWeight: "bold",
    color: theme.palette.white.main,
    // Garante que o cursor de "texto" não apareça sobre o chip
    cursor: "inherit",
    "& .MuiChip-label": {
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      paddingLeft: 1,
      paddingRight: 1,
    },
  },
  boxRenderChip: {
    display: "flex",
    width: "100%",
    overflow: "hidden",
    alignItems: "center",
    pointerEvents: "none",
    gap: 0.5,
  },
});

export default styles;
